<template>
    <button class="codeBtn" :class="send==0?'disableBtn':''" @click.prevent="getCode">
        <span v-show="send==0">{{codeText}}</span>
      <span class="el-icon-message" v-show="send==1"></span>
    </button>
</template>
  
  <script>
    export default {
      mame:'optionButton',
      props:['callback',"emailForm"],
      data(){
          return {
            codeText:'',
            disable: 0, // 禁用样式控制 1----禁用
            send: 1, // 是否能点击 1-可点击 0-不可点击
            time: 60 // 默认时间
        }
      },
      methods: {

        // 获取验证码
        doCallback(){
            if(this.callback){
              return this.callback()
            }
        },
      
        async getCode() {

        if(this.send===1){
          if(!this.send) return false;
          let valid = this.emailForm().validate(async valid=>{
            if(!valid) return valid;

            // 执行发送验证码回调并验证结果
            let callbackValid = await this.doCallback()
            if(!callbackValid)return 

          //倒计时
          this.disable=1
          this.send=0
          let that=this
          that.codeText='60s后重发'
          let timer=setInterval(function(){
            if (that.time>1) {
              that.time--
              that.codeText=that.time+'s后重发'
            } else {
              clearInterval(timer)
              timer=null
              that.disable=0
              that.send=1
              that.time=60
              that.codeText='获取验证码'
            }
          },1000)
        })
        }
      },
    }
}
</script>
  <style lang="less" scoped>
    .codeBtn{
    background-color: @colorMain;
    color: #fff;
    border: none;
    border-radius: 10px;
    &:hover{
        opacity:0.8;
        color: #fff;
        background-color:@colorMain ;
        cursor: pointer;
        }
    }
    .disableBtn{
        opacity: .6 !important;
        cursor: default !important;
    }
      @media screen and (max-width: 765px){
        .codeBtn{
          width: 180px;
          height: 45px;
          border-radius: 6px;
      }
    }

  </style>
  